export default (context, state) => {
  context.state.postures = state[0];
  context.state.golds = state[1];
};



// WEBPACK FOOTER //
// ./resources/js/localState.js